export function normalizeMgmCode(value) {
  return String(value || '').replace(/^MGM:/i, '').trim().toUpperCase();
}
